import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';
var Wrapper = styled.div(_templateObject());
export var IconWithTooltip = function IconWithTooltip(_a) {
  var id = _a.id,
      title = _a.title,
      rest = __rest(_a, ["id", "title"]);

  return React.createElement(Wrapper, {
    id: id,
    title: title
  }, React.createElement(Icon, Object.assign({
    title: title
  }, rest)));
};